var map = {
	"./doc-1.jpg": 73,
	"./doc-2.jpg": 74,
	"./doc-3.jpg": 75,
	"./doc-4.jpg": 76,
	"./doc-5.jpg": 77,
	"./doc-6.jpg": 78,
	"./doc-7.jpg": 79,
	"./doc-8.jpg": 80
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39;